<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <button class="all-btn delete-btn ml-2"
                                        v-if="canReject"
                                        @click="showReject"
                                >
                                    <i class="fa fa-reply"></i>
                                    <span>{{$t("realEstate.action.pending")}}</span>
                                </button>
                            </div>
                        </div>
                        <div class="row" v-if="asset.status === 'Rejected'">
                            <div class="col">
                                <div class="alert alert-danger">
                                    <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган.. <span>{{asset.reasonDesc}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationRespectiveType")}} <span
                                            class="red">*</span></label>
                                    <select class="form-control" v-model="asset.evaluationRespectiveType"
                                            :class="{invalid : $v.asset.evaluationRespectiveType.$error}">
                                        <option :value="option.code" v-for="option in evaluationRespectiveTypes" :key="option.code">
                                            {{option.displayName}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.asset.evlGoalType.$error">
                                        {{$t("realEstate.validation.evaluationRespectiveType")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.ownerClient")}} <span class="red">*</span></label>
                                    <v-select v-model="asset.owner" label="text"
                                              :options="owners"
                                              :filterable="false"
                                              @search="onOwnerSearch"
                                              @search:focus="onOwnerFocus"
                                              :class="{invalid : $v.asset.owner.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="asset && asset.owner && asset.owner.text">
                                            <div v-html="asset.owner.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.asset.owner.$error">
                                        {{$t("realEstate.validation.ownerClient")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-check pl-0">
                                        <label class="form-check-label" style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="asset.hasCustomer">
                                            <span class="form-check-sign"></span>
                                            {{$t("realEstate.field.withLetterOfAttorney")}}
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group" v-if="asset.hasCustomer">
                                    <label>Буйюртмачи <span
                                            class="red">*</span></label>
                                    <v-select v-model="asset.customer" label="text"
                                              :options="customers"
                                              :filterable="false"
                                              @search="onCustomerSearch"
                                              @search:focus="onCustomerFocus"
                                              :class="{invalid : $v.asset.customer.$error}">
                                        <template slot="option" slot-scope="option" v-if="option && option.text">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="asset && asset.customer && asset.customer.text">
                                            <div v-html="asset.customer.text"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.asset.customer.$error">
                                        Буйюртмачи
                                    </div>
                                </div>

                                <div class="form-group" v-if="asset.hasCustomer">
                                    <label>Ишончнома номери: <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="asset.powerOfAttorneyNumber"
                                           :class="{invalid : $v.asset.powerOfAttorneyNumber.$error}"/>
                                    <div class="red" v-if="$v.asset.powerOfAttorneyNumber.$error">Ишончнома номери</div>
                                </div>

                                <div class="form-group" v-if="asset.hasCustomer">
                                    <label>Ишончнома санаси: <span class="red">*</span></label>
                                    <datepicker class="form-control" format="dd/MM/yyyy" v-model="powerOfAttorneyDate"
                                                :clear-button="true" :class="{invalid : $v.powerOfAttorneyDate.$error}"></datepicker>
                                    <div class="red" v-if="$v.powerOfAttorneyDate.$error">Ишончнома санаси:</div>
                                </div>

                                <template v-if="isOrgTypeMib">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibDebtorName")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="asset.mibDebtorName"
                                               :class="{invalid : $v.asset.mibDebtorName.$error}"/>
                                        <div class="red" v-if="$v.asset.mibDebtorName.$error">
                                            {{$t("realEstate.validation.mibDebtorName")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterNumber")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="asset.mibLetterNumber"
                                               :class="{invalid : $v.asset.mibLetterNumber.$error}"/>
                                        <div class="red" v-if="$v.asset.mibLetterNumber.$error">
                                            {{$t("realEstate.validation.mibLetterNumber")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterDate")}} <span
                                                class="red">*</span></label>
                                        <datepicker class="form-control" format="dd/MM/yyyy" v-model="mibLetterDate"
                                                    :clear-button="true"
                                                    :class="{invalid : $v.mibLetterDate.$error}"></datepicker>
                                        <div class="red" v-if="$v.mibLetterDate.$error">
                                            {{$t("realEstate.validation.mibLetterDate")}}
                                        </div>
                                    </div>
                                </template>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationPurpose")}} <span
                                            class="red">*</span></label>
                                    <select class="form-control" v-model="asset.evlGoalType"
                                            :class="{invalid : $v.asset.evlGoalType.$error}">
                                        <option :value="option.code" v-for="option in goalTypes" :key="option.code">
                                            {{option.typeName}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.asset.evlGoalType.$error">
                                        {{$t("realEstate.validation.evaluationPurpose")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.name")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="asset.name"
                                           :class="{invalid : $v.asset.name.$error}"/>
                                    <div class="red" v-if="$v.asset.name.$error">
                                        {{$t("realEstate.validation.name")}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.propertyType")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="asset.evlPropertyType"
                                            :class="{invalid : $v.asset.evlPropertyType.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in propertyTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.asset.evlPropertyType.$error">
                                        {{$t("realEstate.validation.propertyType")}}
                                    </div>
                                </div>

                                <div class="form-group" v-if="hasPermission('ASSET_ASSIGN')">
                                    <label>{{$t("realEstate.field.evaluator")}} <span class="red">*</span></label>
                                    <v-select v-model="asset.employee" label="text"
                                              :options="employees"
                                              :filterable="false"
                                              @search="onEmployeeSearch"
                                              @search:focus="onEmployeeFocus"
                                              :class="{invalid : $v.asset.employee.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="asset && asset.employee && asset.employee.text">
                                            <div v-html="asset.employee.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.asset.employee.$error">
                                        {{$t("realEstate.validation.evaluator")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.contractAmount")}}</label>
                                    <numeric-input class="form-control" v-model="asset.evlContractAmount"
                                                   :controls="false" :precision="2"
                                                   :disabled="isOrgTypeMib || isPaid"></numeric-input>

                                    <div v-if="isOwnerTypeLegal && !isOrgTypeMib">
                                        <label>Олдиндан тўлов фоизи 0% дан 100% гача!</label>
                                        <numeric-input class="form-control" v-model="asset.prepayment"
                                                       :controls="false" :precision="2"></numeric-input>
                                    </div>

                                    <span style="color: green">ҚҚС билан: {{asset.evlAmountToPay | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                    <div class="form-group" style="color: blue"><span>Туланган сумма: {{asset.paidAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span></div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4>{{$t("asset.assetDocs")}}</h4>
                                </div>
                            </div>
                            <template v-if="asset.owner && !isPageLoadInit">

                                <AssetDropZone code="documentsDropZone" :label="documentOrPassportLbl"
                                               folder="Documents" :data="asset.documents"
                                               @change="(files) => {asset.documents = files}"
                                               :has-error="$v.asset.documents.$error"
                                               :removeFile="canRemoveFile"
                                               :editable="canSave"
                                />

                                <template>
                                    <AssetDropZone code="actOfSaleDropZone" label="asset.actOfSale"
                                                   folder="ActOfSale" :data="asset.actOfSale"
                                                   @change="(files) => {asset.actOfSale = files}"
                                                   :has-error="$v.asset.actOfSale.$error"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                    />
                                    <AssetDropZone code="decisionDropZone" label="asset.decision"
                                                   folder="Decision" :data="asset.decision"
                                                   @change="(files) => {asset.decision = files}"
                                                   :has-error="$v.asset.decision.$error"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                    />
                                    <AssetDropZone code="playlistDropZone" label="asset.playlist"
                                                   folder="ExecutivePlaylist" :data="asset.playlist"
                                                   @change="(files) => {asset.playlist = files}"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                    />

                                </template>
                            </template>
                        </div>

                        <div class="row" v-if="asset.id && asset.id > 0">
                              <template>
                                  <PreviewDropZone code="checkPaymentDropZone" :label="checkPaymentLbl"
                                                   :data="asset.checkPaymentFiles"
                                                   @change="(files) => {asset.checkPaymentFiles = files}"
                                  />
                              </template>
                              <div class="form-check checkbox-inline">
                                  <label class="form-check-label pl-3 font-weight-bold">
                                      <input class="form-check-input" type="checkbox"
                                             v-model="asset.displayReport"
                                             @change="showReport()"
                                             v-bind:disabled="!hasPermission('ASSET_DISPLAY_REPORT')"
                                      >
                                      <span class="form-check-sign"></span>
                                      {{$t("report.field.showReport")}}
                                  </label>
                              </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 col-12 mt-2">
                                <div class="form-group">
                                    <asset-status-view :asset="asset"/>
                                </div>
                            </div>
                            <div class="col-md-6 col-12 mt-2">
                                <div class="form-group">
                                    <asset-history-view v-if="asset.id"/>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="showReportButton">
                            <div class="col-12 btns-box">
                                <button
                                        class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('ASSET_REPORT_WORD')"
                                        @click="reportDocQrCode(asset)">
                                    <i v-if="loading.isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWordQrCode")}}
                                </button>
                                <button
                                        class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('ASSET_REPORT_WORD')"
                                        @click="reportDoc(asset)">
                                    <i v-if="loading.isDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWord")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('ASSET_REPORT_PDF_QR_CODE')"
                                        @click="reportPdfQrCode(asset)">
                                    <i v-if="loading.isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('ASSET_REPORT_PDF')"
                                        @click="reportPdf(asset)">
                                    <i v-if="loading.isPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.title")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('ASSET_CONTRACT_PDF_QR_CODE')"
                                        @click="contractQrCodePdf(asset)">
                                    <i v-if="loading.isCPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdfQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('ASSET_CONTRACT_PDF')"
                                        @click="contractPdf(asset)">
                                    <i v-if="loading.isCPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdf")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('ASSET_CONTRACT_WORD')"
                                        @click="contractDocQrCode(asset)">
                                    <i v-if="loading.isCDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWordQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('ASSET_CONTRACT_WORD')"
                                        @click="contractDoc(asset)">
                                    <i v-if="loading.isCDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWord")}}
                                </button>
                            </div>
                        </div>

                        <div class="row" v-if="asset.id && asset.id > 0">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4 class="pull-left">
                                        {{$t("asset.assetToEvaluate")}}
                                    </h4>
                                    <button class="all-btn add-btn pull-right ml-2" v-if="canSave" @click="addAsset">
                                        {{$t("asset.titleAddEdit")}}
                                    </button>
                                </div>
                                <div class="table-responsive">
                                  <div class="table-wrapper">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th width="5%">№</th>
                                            <th width="30%">Бино номи</th>
                                            <th width="15%">Вилоят</th>
                                            <th width="15%">Туман</th>
                                            <th width="15%">БАХОЛАНГАН ҚИЙМАТИ</th>
                                            <th width="100%">ЖАРАЁН</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(assetItem, index) in asset.assetItemDtos" :key="assetItem.id">
                                            <td>{{index+1}}</td>
                                            <td>{{assetItem.name}}</td>
                                            <td>{{assetItem.province.name}}</td>
                                            <td>{{assetItem.region.name}}</td>
                                            <td>
                                                {{assetItem.evlTotal | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                            </td>
                                            <td class="td-actions text-center direction-row">
                                                <router-link tag="button"
                                                             :to="`/asset${$route && $route.meta.version ? '-plus': ''}/item/edit/` + assetItem.id"
                                                             v-tooltip="'Ўзгартириш'"
                                                             class="all-btn edit-btn table-action">
                                                    <i class="fa fa-edit"></i>
                                                </router-link>
                                                <button type="button" v-tooltip="'Ўчириш'" v-if="canSave"
                                                        class="all-btn delete-btn table-action"
                                                        @click="showDeleteAssetItemDialog(assetItem, index)">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5 justify-content-center">
                              <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                  {{$t("action.cancel")}}
                              </button>
                              <button class="all-btn add-btn ml-3" v-if="canSave" @click="save" :disabled="processing">
                                  {{$t("action.save")}}
                              </button>
                              <button class="all-btn ml-3" @click="changeStatus('Evaluated')"
                                      :disabled="processing" v-if="canEvaluate">{{$t("realEstate.action.evaluate")}}
                              </button>
                              <button class="all-btn add-btn ml-3" @click="changeStatus('Confirmed')"
                                      :disabled="processing" v-if="canConfirm && (asset.appraiserReportEsp || !asset.hasEsp)">{{$t("realEstate.action.confirm")}}
                              </button>
                              <button class="all-btn edit-btn ml-3" @click="changeStatus('NotFullyEvaluated')"
                                      :disabled="processing" v-if="canReEvaluate">
                                  {{$t("realEstate.action.reevaluate")}}
                              </button>

                            <button class="all-btn add-btn ml-3" @click="sendReportToMIBAsset(asset)"
                                    v-if="hasPermission('SEND_TO_MIB_ASSET') && isMib && asset.status === 'Confirmed'">
                                {{$t("realEstate.action.sendReportToMIB")}}
                            </button>
                            <button class="all-btn ml-3" v-if="canSendAgent"
                                    :disabled="processing"
                                    @click="changeStatus('NotReady')">
                                {{$t('main.send')}}
                            </button>
                            <button class="all-btn pull-right ml-3"
                                    v-tooltip="'ЭЦПни тасдиқлаш'"
                                    v-if="canSignEsp"
                                    @click="onSignDirectorEsp"
                            >
                                {{$t("realEstate.action.espSign")}}
                            </button>
                            <button class="all-btn pull-right ml-3"
                                    v-if="canSignEspAppraisal"
                                    @click="onSignAppraiserEsp"
                            >
                                {{$t("realEstate.action.espSign")}}
                            </button>
                              <!-- <router-link
                                      tag="button"
                                      v-tooltip="'ЭЦПни тасдиқлаш'"
                                      :to="'/asset/esp/' + asset.id"
                                      class="all-btn pull-right ml-3"
                                      v-if="hasPermission('ASSET_CONFIRM') && asset.status === 'Confirmed' && asset.hasEsp"
                              >
                                  {{$t("realEstate.action.espSign")}}
                              </router-link> -->
                        </div>
                        <div class="row mt-3" v-if="asset.status === 'Confirmed'">
                            <div class="col">
                                <div class="alert alert-warning d-flex">
                                    <i class="fa-fw fa fa-warning mr-1"></i>
                                    <label style="color: #4d2600; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong> Тасдиқлагандан (қайта Тасдиқлагандан сўнг хам) ЭЦПни имзоланг. ЭЦП имзолаш тугмасини босинг!</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template>
            <b-modal v-model="show" title="Аралаш мол-мулкни бекор қилиш">
                <div class="container-fluid px-0">
                    <div class="form-group">
                        <label>Бекор қилиш сабабини киритинг<span class="red">*</span></label>
                        <textarea class="form-control"
                                  v-model="asset.reasonDesc">
                        </textarea>
                    </div>
                </div>
                <div slot="modal-footer">
                    <button
                            type="button"
                            class="all-btn add-btn float-right ml-2"
                            @click="rejectAppraisal('Rejected')"
                    >{{$t("action.save")}}
                    </button>
                    <button
                            type="button"
                            class="all-btn delete-btn float-right"
                            @click="rejectModalHide"
                    >{{$t("action.cancel")}}
                    </button>
                </div>
            </b-modal>
        </template>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {numericTypes} from '@/shared/constants/mask'
    import {EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    import AssetDropZone from '@/views/asset/AssetDropZone'
    import {required, requiredUnless, minLength} from 'vuelidate/lib/validators';
    import {formatDate, parseDate} from '@/shared/utils';
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import AssetStatusView from './AssetStatusView.vue'
    import AssetHistoryView from './AssetHistoryView.vue'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import {mapState} from "vuex";

    export default {
        name: "AssetEdit",
        components: {
            AssetDropZone,
            Datepicker,
            PreviewDropZone,
            AssetStatusView,
            AssetHistoryView,
            'b-modal': bModal
        },
        data() {
            return {
                processing: false,
                loading: {
                    isDocQrLoading: false,
                    isDocLoading: false,
                    isPdfLoading: false,
                    isPdfQrLoading: false,
                    isCDocLoading: false,
                    isCPdfLoading: false,
                    isCDocQrLoading: false,
                    isCPdfQrLoading: false
                },
                show: false,
                numericTypes: numericTypes,
                ownerFilter: initFilterModel(),
                customerFilter: initFilterModel(),
                employeeFilter: initFilterModel(),
                asset: {
                    id: null,
                    owner: {},
                    evlGoalType: 'Predge',
                    name: '',
                    evlContractAmount: 0,
                    prepayment: 0,
                    employee: {},
                    evlValueType: 'Market',
                    evlPropertyType: '',

                    mibDebtorName: '',
                    mibLetterNumber: '',
                    mibLetterDate: null,
                    displayReport: false,
                    hasCustomer: false,
                    customer: null,
                    powerOfAttorneyDate: null,
                    powerOfAttorneyNumber: null,
                    assetItemDtos: [],

                    documents: [],
                    actOfSale: [],
                    decision: [],
                    playlist: [],
                    checkPaymentFiles: [],// to'lov haqidagi hujjatlar
                    status: 'Pending',
                    evaluationRespectiveType: "OTHER"
                },
                mibLetterDate: null,
                powerOfAttorneyDate: null,
                owners: [],
                customers: [],
                employees: [],
                goalTypes: [], //EVL_GOAL_TYPES,
                propertyTypes: EVL_PROPERTY_TYPES,
                evaluationRespectiveTypes: [],
                isPageLoadInit: false,
                status: null
            }
        },
        validations() {
            return {
                asset: {
                    owner: {
                        required: required
                    },
                    customer: {
                        required: requiredUnless(() => {
                            return !(this.asset.hasCustomer);
                        })
                    },
                    powerOfAttorneyNumber: {
                        required: requiredUnless(() => {
                            return !(this.asset.hasCustomer);
                        })
                    },
                    evlGoalType: {
                        required: required
                    },
                    name: {
                        required: required
                    },
                    evlPropertyType: {
                        required: required
                    },
                    employee: {
                        id: {
                            required: required
                        }
                    },
                    documents: {
                        required: requiredUnless(() => {
                            return this.isMib || !!this.hasSourceExpert2;
                        }),
                        minLength: minLength(1)
                    },
                    actOfSale: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    decision: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    // MIB
                    mibDebtorName: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    },
                    mibLetterNumber: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    },
                    evaluationRespectiveType: {
                        required: required
                    },
                },
                mibLetterDate: {
                    required: requiredUnless(() => {
                        return !(this.isOrgTypeMib);
                    })
                },
                powerOfAttorneyDate: {
                    required: requiredUnless(() => {
                        return !(this.asset.hasCustomer);
                    })
                }
            };
        },
        computed: {
            ...mapState(['profile']),
            isOwnerTypePhysical() {
                return !!(this.asset.owner && this.asset.owner.type && this.asset.owner.type === 'Physical');
            },
            isOwnerTypeLegal() {
                return !!(this.asset.owner && this.asset.owner.type && this.asset.owner.type === 'Legal');
            },
            isMib() {
                return !!(this.asset.owner && this.asset.owner.organizationType && this.asset.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');

            },
            isOrgTypeMib() {
                return !!(this.asset.owner &&
                    this.asset.owner.organizationType &&
                    (this.asset.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.asset.owner.organizationType === 'CUSTOMS_ADMINISTRATION'));
            },
            documentOrPassportLbl() {
                if (this.asset) {
                    if (this.asset.owner && this.asset.owner.type && this.asset.owner.type === 'Legal')
                        return "asset.document";
                    else
                        return "asset.passport";
                } else {
                    return "asset.passport";
                }
            },
            canConfirm() {
                return this.asset.status === 'Evaluated';
            },
            canReEvaluate() {
                return (this.asset.status === 'Evaluated' || this.asset.status === 'Confirmed') && this.hasPermission('ASSET_REEVALUATE');
            },
            canSave() {
                return (this.asset.status === 'Pending' || this.asset.status === 'AssignedToEvaluator' ||
                    this.asset.status === 'NotFullyEvaluated' || this.asset.status === 'SentToComplement');
            },
            canEvaluate() {
                return (this.asset.status === 'NotFullyEvaluated');
            },
            showReportButton() {
                return (this.asset.status === 'Evaluated' || this.asset.status === 'Confirmed') && this.asset.id && this.asset.id > 0;
            },
            sendToMIBAssetReport() {
                return (this.asset.status === 'Evaluated' || this.asset.status === 'Confirmed') && this.asset.id && this.asset.id > 0;
            },
            checkPaymentLbl() {
                return this.isOrgTypeMib ? "realEstate.field.checkPaymentFilesMib" : "realEstate.field.checkPaymentFiles";
            },
            isPaid() {
                return this.asset.paidAmount > 0;
            },
            canRemoveFile() {
                return this.status && this.status!== 'Evaluated' && this.status!== 'Confirmed' && this.status!=='Rejected' && this.hasPermission('ASSET_IMAGE_DELETE');
            },
            canSignEsp() {
                return this.hasPermission('ASSET_CONFIRM') && this.asset.status === 'Confirmed' && this.asset.appraiserReportEsp && this.asset.hasEsp && !this.asset.directorReportEsp
            },
            canSignEspAppraisal() {
                return this.asset.status === 'Evaluated' && this.asset.hasEsp && !this.asset.appraiserReportEsp
            },
            canSendAgent() {
                return (this.asset.status === 'SentToComplement' && this.hasPermission('ASSET_EDIT'))
            },
            isSentToComplement() {
                return (this.asset.status === 'SentToComplement')
            },
            hasSourceExpert2() {
                return this.asset.source === 'EXPERT2';
            },
            isUserDirector() {
              return this.profile && this.profile.username === 'shohrux';
            },
            canReject() {
              return this.hasPermission('E_BAHOLASH_ASSET_REJECT') && (this.asset.status === 'AssignedToEvaluator' || (this.asset.status === 'NotFullyEvaluated' && this.isUserDirector))
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                const promises = [
                    this.$http.get('dictionary/evaluation-goal-type')
                ];
                if (id && id > 0) {
                    vm.isPageLoadInit = true;
                    promises.push(this.$http.get('asset/' + id));
                }

                Promise.all(promises).then(function (values) {
                    vm.goalTypes = values[0].data;

                    if (values.length >= 2) {
                        const editData = values[1].data;
                        if (!editData.evlGoalType) {
                            editData.evlGoalType = '';
                        }

                        if (!editData.employee) {
                            editData.employee = {};
                        }
                        vm.mibLetterDate = parseDate(editData.mibLetterDate);
                        vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
                        vm.asset = editData;

                        vm.status = editData.status;
                        vm.isPageLoadInit = false;
                    }
                });
            },
            cancel() {
              const version = this.asset.version
              if (version === 'V3') {
                this.$router.push('/asset-plus');
              } else {
                this.$router.push('/asset');
              }
            },
            save() {
                this.saveAndGo();
            },
            saveAndGo() {

                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                if (this.asset.prepayment && !(this.asset.prepayment >= 0 && this.asset.prepayment <= 100)) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
                        type: 'warning'
                    });
                    return ;
                }

                this.processing = true;

                if (this.mibLetterDate) {
                    this.asset.mibLetterDate = formatDate(this.mibLetterDate);
                }

                if (this.powerOfAttorneyDate) {
                    this.asset.powerOfAttorneyDate = formatDate(this.powerOfAttorneyDate);
                }

                this.$http.post('asset/save', this.asset)
                    .then(res => {

                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.statusSuccess'),
                                type: 'success'
                            });
                            this.$router.push('/asset');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.realEstate.statusWarning'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            addAsset() {
                this.$router.push('/asset/item/new/' + this.asset.id);
            },
            onOwnerSearch(searchTxt, loading) {
                loading(true);
                this.owners = [];
                this.ownerFilter.search = searchTxt;
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        console.log("S")
                        this.owners = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onOwnerFocus() {
                this.owners = [];
                this.ownerFilter.search = '';
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                        console.log(res.data)
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerSearch(searchTxt, loading) {
                loading(true);
                this.customers = [];
                this.customerFilter.search = searchTxt;
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerFocus() {
                this.customers = [];
                this.customerFilter.search = '';
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onEmployeeSearch(searchTxt, loading) {
                loading(true);
                this.employees = [];
                this.employeeFilter.search = searchTxt;
                this.$http.post('employes/search', this.employeeFilter)
                    .then(res => {
                        this.employees = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onEmployeeFocus() {
                this.employees = [];
                this.employeeFilter.search = '';
                this.$http.post('employes/search', this.employeeFilter)
                    .then(res => {
                        this.employees = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            showDeleteAssetItemDialog(assetItem, index) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('asset.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('asset/item/delete/' + assetItem.id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.building.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.asset.assetItemDtos.splice(index, 1);
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.building.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            changeStatus(status) {
                this.processing = true;
                this.isPageLoadInit = true;

                this.$http.get('contractRegion/check-contract/' + this.asset.id + "/Asset").then(response => {
                    if (response.data.status !== 'SUCCESS' || response.data.status === 'SUCCESS' && response.data.code === 'ALLOWED') {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: response.data.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#dd3333',
                            confirmButtonText: 'Давом этиш',
                            cancelButtonText: 'Бекор қилиш'
                        }).then((result) => {
                            if (result.value) {
                                this.sendChangesToServer(status);
                            }
                            this.processing = false;
                        });
                    } else {
                        this.sendChangesToServer(status);
                    }
                });
            },
            sendChangesToServer(status){
                if (status === 'NotReady') {
                    this.$v.$touch();
                    if (this.$v.$invalid) {
                        return;
                    }
                }
                this.$http.post('asset/status', {
                    id: this.asset.id,
                    status: status,
                }).then(res => {
                    if (res && res.data) {
                        if (res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('asset.statusSuccess'),
                                type: 'success'
                            });
                            this.asset.status = status;
                            this.status = status;
                            if (status === 'Confirmed') {
                                if (this.asset.hasEsp) {
                                    this.onSignDirectorEsp()
                                    // this.$router.push('/asset/esp/' + this.asset.id)
                                }
                            } else if (status === 'Evaluated') {
                                if (this.asset.hasEsp) {
                                    this.onSignAppraiserEsp()
                                    // this.$router.push('/asset/appraiser-report/esp/' + this.asset.id)
                                }
                            }
                        } else if (res.data.status === 'FAIL') {
                            if (res.data.code === 'NOT_COORDINATED') {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.$t('Кўчмас мулкни мувофиқлаштиринг!'),
                                    type: 'warning'
                                });
                                if (this.asset.version === "V2"){
                                    this.$router.push('/asset/new-real-estate/coordination/' + res.data.data.id + '/' + false);
                                } else {
                                    this.$router.push('/asset/real-estate/coordination/' + res.data.data.id);
                                }
                            } else if (res.data.code === 'COST_NOT_FOUND') {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.$t('Харажат ёндашув танланган лекин ундан фойдаланилмаган!'),
                                    type: 'warning'
                                });
                                if (this.asset.version === "V2"){
                                    this.$router.push('/asset/new-real-estate/coordination/' + res.data.data.id + '/' + false);
                                } else {
                                    this.$router.push('/asset/real-estate/coordination/' + res.data.data.id);
                                }
                            } else if (res.data.code === 'COMPARATIVE_NOT_FOUND') {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.$t('Қийосий ёндашув танланган лекин ундан фойдаланилмаган!'),
                                    type: 'warning'
                                });
                                if (this.asset.version === "V2"){
                                    this.$router.push('/asset/new-real-estate/coordination/' + res.data.data.id + '/' + false);
                                } else {
                                    this.$router.push('/asset/real-estate/coordination/' + res.data.data.id);
                                }
                            } else if (res.data.code === 'INCOME_NOT_FOUND') {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.$t('Даромад ёндашув танланган лекин ундан фойдаланилмаган!'),
                                    type: 'warning'
                                });
                                if (this.asset.version === "V2"){
                                    this.$router.push('/asset/new-real-estate/coordination/' + res.data.data.id + '/' + false);
                                } else {
                                    this.$router.push('/asset/real-estate/coordination/' + res.data.data.id);
                                }
                            }
                        } else if (res.data.status === 'ERROR') {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning'});
                        }
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('asset.statusWarning'),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                    this.isPageLoadInit = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('asset.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                    this.isPageLoadInit = false;
                });
            },
            onSignAppraiserEsp() {
                this.$http.get(`esign/appraiser/${this.asset.id}/Asset`)
                    .then(res => {
                        if (res.data && res.data.status === 'SUCCESS') {
                            window.open(res.data.data, '_blank');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: res.data.message,
                                type: 'warning'
                            });
                        }
                    }, err => {
                        console.log(err);
                    })
            },
            onSignDirectorEsp() {
                this.$http.get(`esign/director/${this.asset.id}/Asset`)
                    .then(res => {
                        if (res.data && res.data.status === 'SUCCESS') {
                            window.open(res.data.data, '_blank');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: res.data.message,
                                type: 'warning'
                            });
                        }
                    }, err => {
                        console.log(err);
                    })
            },
            reportPdf: function (asset) {
                this.loading.isPdfLoading = true;
                this.downloadFile('/v2/assetReport/pdf/' + asset.hashUuid + '/WITH_SIGNATURE',
                    'Хисобот ' + asset.owner.fullName + '.pdf',
                    'application/pdf',
                    'isPdfLoading');
            },
            reportPdfQrCode: function (asset) {
                this.loading.isPdfQrLoading = true;
                this.downloadFile('/v2/assetReport/pdf/' + asset.hashUuid + '/WITH_QR_CODE',
                    'Хисобот ' + asset.owner.fullName + '.pdf',
                    'application/pdf',
                    'isPdfQrLoading');
            },
            reportDoc: function (asset) {
                this.loading.isDocLoading = true;
                this.downloadFile('/v2/assetReport/doc/' + asset.hashUuid + '/WITH_SIGNATURE',
                    'Хисобот ' + asset.owner.fullName + '.doc',
                    'application/doc',
                    'isDocLoading');
            },
            reportDocQrCode: function (asset) {
                this.loading.isDocQrLoading = true;
                this.downloadFile('/v2/assetReport/doc/' + asset.hashUuid + '/WITH_QR_CODE',
                    'Хисобот ' + asset.owner.fullName + '.doc',
                    'application/doc',
                    'isDocQrLoading');
            },
            downloadFile: function (url, name, type, loading) {
                this.$http.get(url, {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: type});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = name;
                        link.click();
                        this.loading[loading] = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading[loading] = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.downloadFile(url, name, type, loading))
                        }
                    })
            },
            contractDocQrCode: function (asset) {
                this.loading.isCDocQrLoading = true;
                this.downloadFile('/v2/assetContract/doc/' + asset.hashUuid + '/WITH_QR_CODE',
                    'Шартнома ' + asset.owner.fullName + '.doc',
                    'application/doc',
                    'isCDocQrLoading');
            },
            contractDoc: function (asset) {
                this.loading.isCDocLoading = true;
                this.downloadFile('/v2/assetContract/doc/' + asset.hashUuid + '/WITH_SIGNATURE',
                    'Шартнома ' + asset.owner.fullName + '.doc',
                    'application/doc',
                    'isCDocLoading');
            },
            contractPdf: function (asset) {
                this.loading.isCPdfLoading = true;
                this.downloadFile('/v2/assetContract/pdf/' + asset.hashUuid + '/WITH_SIGNATURE',
                    'Шартнома ' + asset.owner.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfLoading');
            },
            contractQrCodePdf: function (asset) {
                this.loading.isCPdfQrLoading = true;
                this.downloadFile('/v2/assetContract/pdf/' + asset.hashUuid + '/WITH_QR_CODE',
                    'Шартнома ' + asset.owner.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfQrLoading');
            },

            sendReportToMIBAsset: function (asset) {
                this.processing = true;
                this.$http.get('/sendApiMibConfirmReport/pdf/' + asset.id + '/WITH_QR_CODE/Asset', {responseType: 'arraybuffer'})
                    .then(response => {
                        if (response && response.status ===200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('realEstate.report.titleQrCode'),
                                type: 'success'
                            });
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.error'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('messages.common.error'),
                            type: 'warning'
                        });
                        this.processing = false;
                    })
            },
            showReport: function () {
                this.$http.post('asset/show-report/' + this.asset.id + '/' + this.asset.displayReport)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showReportSuccess'),
                                type: 'success'
                            });
                            this.asset.status = status;
                        } else if (res && res.data && res.data.status === 'FAIL') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showCancelReportSuccess'),
                                type: 'success'
                            });
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.showReportError'),
                            type: 'error'
                        });
                    });
            },
            getEvaluationRespectiveType() {
                this.$http.get('/evaluationRespectiveType').then(response => {
                    this.evaluationRespectiveTypes = response.data;
                },err => {
                    console.log(err)
                });
            },
            showReject() {
                this.asset.reasonDesc = '';
                this.show = true;
            },
            rejectModalHide() {
                this.show = false;
            },
            rejectAppraisal(status) {
                if (this.asset.reasonDesc) {
                    this.processing = true;
                    this.$http.post('asset/e-appraisal/status/reject', {
                        id: this.asset.id,
                        status: status,
                        reasonDesc: this.asset.reasonDesc
                    }).then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.show = false;
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('asset.statusSuccess'),
                                type: 'success'
                            });
                            this.asset.status = status;
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('asset.statusWarning'),
                                type: 'warning'
                            });
                            this.show = false;
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('asset.statusError'),
                            type: 'error'
                        });
                        this.show = false;
                        this.processing = false;
                    })
                } else {
                    this.$swal({
                        title: 'Хабар!',
                        text: 'Бекор қилиш сабабини киритинг!',
                        type: 'warning'
                    });
                }
            },
        },
        created() {
            this.init();
            this.getEvaluationRespectiveType();
        }
    }
</script>

<style scoped>

</style>
